import {CoMailOpen} from "@onemind-services-llc/react-icons-ng/co";
import {FaLocationArrow, FaPhoneAlt} from "@onemind-services-llc/react-icons-ng/fa";
import {MdOutlineSupport} from "@onemind-services-llc/react-icons-ng/md";
import {CLOUD_SERVICES_ROUTES, MAIN_ROUTES} from "@/constants/routes";

export const FOOTER_CONSTANTS = {
  BRAND_TEXT: "“Cloud Simplified, Security Amplified”",
  CONTACT_INFO: "CONTACT INFO",
  DONT_MISS_UPDATES: "Don't miss our future updates. Get subscribed today !",
  IAAS_SERVICE: "IAAS",
  POLICIES: "POLICIES",
  RIGHTS: `© 2016 - ${new Date().getFullYear()} | All rights reserved by OneMind Services LLC`,
  SUPPORT: "SUPPORT",
  SERVICES: "SERVICE",
  SUBSCRIBE: "Subscribe For Newsletter",
};

export const CONTACT_INFO_LIST = [
  {
    icon: CoMailOpen,
    label: "sales@onemindservices.com",
    path: "mailto:sales@onemindservices.com",
  },
  {
    icon: MdOutlineSupport,
    label: "support@onemindservices.com",
    path: "mailto:support@onemindservices.com",
  },

  {icon: FaPhoneAlt, label: "1-408-540-6771", path: "tel:1-408-540-6771"},
  {
    icon: FaLocationArrow,
    label: "11501 Dublin Bvld, Suite#200 Dublin CA 94568",
    path: "https://maps.google.com?q=11501 Dublin Bvld, Suite#200 Dublin CA 94568",
    ext_link: true,
  },
];

export const SERVICE_OPTIONS = [
  {
    name: "Cloud Services",
    path: `${MAIN_ROUTES.CLOUD_SERVICES}`,
  },
  {
    name: "Public Cloud",
    path: `${MAIN_ROUTES.CLOUD_SERVICES}?tab=0`,
  },
  {
    name: "Private Cloud",
    path: `${MAIN_ROUTES.CLOUD_SERVICES}?tab=1`,
  },
  {
    name: "POC Cloud",
    path: `${MAIN_ROUTES.CLOUD_SERVICES}?tab=2`,
  },
  {
    name: "Security Services",
    path: `${MAIN_ROUTES.SECURITY_SERVICES}`,
  },
  {
    name: "Network Services",
    path: `${MAIN_ROUTES.NETWORK_SERVICES}`,
  },
  {
    name: "Application Services",
    path: `${MAIN_ROUTES.APPLICATION_SERVICES}`,
  },
];

export const PUBLIC_CLOUD_SERVICES = [
  {
    name: "Bare-Metal Server",
    path: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.BAREMETAL}`,
  },
  {
    name: "Dedicated Servers",
    path: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.DEDICATED_SERVER}`,
  },
  {
    name: " Cloud GPU ",
    path: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.CLOUD_GPU}`,
  },
  // {
  //   name: "Platform as a Service (PaaS)",
  //   path: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.PAAS}`,
  // },
  {
    name: "Kubernetes",
    path: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.KUBERNETES}`,
  },
  {
    name: "Virtual Desktop Infrastructure (VDI) ",
    path: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.VDI}`,
  },
  {
    name: "Block Storage | S3 Storage ",
    path: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.BLOCK_AND_S3_STORAGE}`,
  },
  {
    name: "Managed Microsoft 365",
    path: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.MICROSOFT_365}`,
  },
];

export const SUPPORT_OPTIONS = [
  {name: "Home", path: "/"},
  {
    name: "Pricing",
    path: MAIN_ROUTES.PRICING,
  },
  {
    name: "About us",
    path: MAIN_ROUTES.ABOUT_US,
  },
  {
    name: "Data Centers",
    path: MAIN_ROUTES.DATA_CENTER,
  },
  {
    name: "Case Studies",
    path: MAIN_ROUTES.CASE_STUDIES,
  },
  {
    name: "Careers",
    path: "http://careers.onemindservices.com/",
  },
  {
    name: "Contact Us",
    path: MAIN_ROUTES.BOOK_A_CONSULTATION,
  },
  {
    name: "Policies",
    path: MAIN_ROUTES.POLICIES,
  },
];

export const POLICIES_OPTION = [
  {
    name: "General Policies",
    path: `${MAIN_ROUTES.POLICIES}?policy=general-policies`,
  },
  {
    name: "Accepted Use Policy ",
    path: MAIN_ROUTES.ACCEPTED_USE_POLICY,
  },
  {
    name: "Code Of Conduct",
    path: MAIN_ROUTES.CODE_OF_CONDUCT,
  },
  {
    name: "Dedicated Servers Policies",
    path: `${MAIN_ROUTES.POLICIES}?policy=dedicated-servers-policies`,
  },
  {
    name: "Cloud Servers Policies",
    path: `${MAIN_ROUTES.POLICIES}?policy=cloud-servers-policies`,
  },
  {
    name: "Colocation Policies",
    path: `${MAIN_ROUTES.POLICIES}?policy=colocation-policies`,
  },
];
